export default class simpleCarousel {
    /*
     * Fires first
     */
    constructor() { 

        /*
        * Initialize slider
        */
        $('.js-simple-carousel').slick({
            autoplay: false,
            autoplaySpeed: 4500,
            arrows: true,
            dots: true, 
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: false,
            // nextArrow: '<button class="slick-slider__arrow-next w-4 h-8 absolute -right-12 top-1/2 translate-y-1/2 focus:outline-none focus:outline-none bg-center bg-no-repeat bg-contain"></button>',
            // prevArrow: '<button class="slick-slider__arrow-prev w-4 h-8 absolute -left-12 top-1/2 translate-y-1/2 focus:outline-none focus:outline-none bg-center bg-no-repeat bg-contain"></button>',
            responsive: [
				{
					breakpoint: 1024,
					settings: {
                        arrows: false,
						slidesToShow: 1,
                        slidesToScroll: 1,
					},
				},
				{
					breakpoint: 768,
					settings: {
                        arrows: false,
						slidesToShow: 1,
                        slidesToScroll: 1,
					},
				},
			],
        });

        $('.js-simple-carousel-rtl').slick({
            autoplay: false,
            autoplaySpeed: 4500,
            arrows: true,
            dots: true, 
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: false,
            // nextArrow: '<button class="slick-slider__arrow-next w-4 h-8 absolute -right-12 top-1/2 translate-y-1/2 focus:outline-none focus:outline-none bg-center bg-no-repeat bg-contain"></button>',
            // prevArrow: '<button class="slick-slider__arrow-prev w-4 h-8 absolute -left-12 top-1/2 translate-y-1/2 focus:outline-none focus:outline-none bg-center bg-no-repeat bg-contain"></button>',
            rtl: true,
            responsive: [
				{
					breakpoint: 1024,
					settings: {
                        arrows: false,
						slidesToShow: 1,
                        slidesToScroll: 1,
					},
				},
				{
					breakpoint: 768,
					settings: {
                        arrows: false,
						slidesToShow: 1,
                        slidesToScroll: 1,
					},
				},
			],
        });

        $('.js-simple-carousel-rtl').slick({
            autoplay: false,
            autoplaySpeed: 4500,
            arrows: true,
            dots: true, 
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: false,
            rtl: true,
            // nextArrow: '<button class="slick-slider__arrow-next w-4 h-8 absolute -right-12 top-1/2 translate-y-1/2 focus:outline-none focus:outline-none bg-center bg-no-repeat bg-contain"></button>',
            // prevArrow: '<button class="slick-slider__arrow-prev w-4 h-8 absolute -left-12 top-1/2 translate-y-1/2 focus:outline-none focus:outline-none bg-center bg-no-repeat bg-contain"></button>',
            responsive: [
				{
					breakpoint: 1024,
					settings: {
                        arrows: false,
						slidesToShow: 1,
                        slidesToScroll: 1,
					},
				},
				{
					breakpoint: 768,
					settings: {
                        arrows: false,
						slidesToShow: 1,
                        slidesToScroll: 1,
					},
				},
			],
        });

        this.addEvents();
    }

     /*
     * Add events
     */
     addEvents(){ 
      
        $('.js-simple-carousel, .js-simple-carousel-rtl').on('beforeChange', function(event, slick, currentSlide, nextSlide){ 
            let direction = '';
            if (Math.abs(nextSlide - currentSlide) == 1) {
                direction = (nextSlide - currentSlide > 0) ? "left navigation": "right navigation" ;
            } else {
                direction = (nextSlide - currentSlide > 0) ? "right navigation" :  "left navigation" ;
            }

            if( slick.$slider.closest('section').hasClass('creative-corner-categories')  ){ 
                _satellite.track("carousel_interaction", {
                    carousel_interaction_type : direction,
                    carousel_id: "ec8337",
                    carousel_name: "Creative Corner - Home - For home",
                    carousel_item: "For home",
                    carousel_type: "link",
                }); 
            }

            if( slick.$slider.closest('section').hasClass('featured-pdf-download') || slick.$slider.closest('section').hasClass('latest-blog-posts') ){
                _satellite.track("carousel_interaction", {
                    carousel_interaction_type : direction,
                    carousel_id: "dw8337",
                    carousel_name: "Creative Corner - Home - For business",
                    carousel_item: "Office/Work",
                    carousel_type: "download",
                }); 
            } 
           
        });
     }
}
